import { render } from "./TierDefineStep.vue?vue&type=template&id=b8daf58c"
import script from "./TierDefineStep.vue?vue&type=script&lang=js"
export * from "./TierDefineStep.vue?vue&type=script&lang=js"

import "./TierDefineStep.vue?vue&type=style&index=0&id=b8daf58c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__